import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import { cn } from "@omni/utils/styles";

import { AddressBlock } from "@/components/Account/Profile/ProfileAddressBook/components/AddressBlock/addressBlock.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    addresses: Array<CloudCustomerAddress>;
    canDelete: boolean;
    updateDefaultBilling: (address: CloudCustomerAddress) => Promise<void>;
    updateDefaultDelivery: (address: CloudCustomerAddress) => Promise<void>;
};

const OtherAddresses = ({
    addresses,
    canDelete,
    updateDefaultBilling,
    updateDefaultDelivery
}: Props) => {
    const { t } = useGranite();

    return (
        <>
            {addresses.length > 0 && (
                <>
                    <Row className={cn("mt-3")}>
                        <Col>
                            <h3>{t("address.title.others")}</h3>
                            <Divider />
                        </Col>
                    </Row>
                    <Row>
                        {addresses.map((address) => (
                            <Col
                                xs={12}
                                md={6}
                                key={address.id}
                                className={cn("mt-3")}
                            >
                                <AddressBlock
                                    address={address}
                                    updateDefaultDelivery={
                                        updateDefaultDelivery
                                    }
                                    updateDefaultBilling={updateDefaultBilling}
                                    canDelete={canDelete}
                                />
                            </Col>
                        ))}
                    </Row>
                </>
            )}
        </>
    );
};

export default OtherAddresses;
